import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_API_URL;

// -------- Thunks ---------

export const fetchComplainData = createAsyncThunk(
    'ShowAllTask/fetchComplainData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/ConplainController/dfshfsdfgjftghjfghjghx`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchComplainIdData = createAsyncThunk(
    'ShowAllTask/fetchComplainIFData',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/ConplainController/dfshfsdfgjftghjfghjgh/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchTaskData = createAsyncThunk(
    'ShowAllTask/fetchTaskData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/TaskManagement/AssignTaskDataFun`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchSubTaskData = createAsyncThunk(
    'ShowAllTask/fetchSubTaskData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/TaskManagement/AssignSubTaskDataFun`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// -------- Slice --------

const ShowAllTask = createSlice({
    name: 'ShowAllTaskSlice',
    initialState: {
        ComplainData: [],
        complainDataLoading: false,
        complainDataError: null,

        ComplainIdData: null,
        complainIFLoading: false,
        complainIFError: null,

        TaskData: [],
        taskDataLoading: false,
        taskDataError: null,

        SubTaskData: [],
        subTaskLoading: false,
        subTaskError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // Complain Data
            .addCase(fetchComplainData.pending, (state) => {
                state.complainDataLoading = true;
                state.complainDataError = null;
            })
            .addCase(fetchComplainData.fulfilled, (state, action) => {
                state.complainDataLoading = false;
                state.ComplainData = action.payload;
            })
            .addCase(fetchComplainData.rejected, (state, action) => {
                state.complainDataLoading = false;
                state.complainDataError = action.payload;
            })

            // Complain IF by ID
            .addCase(fetchComplainIdData.pending, (state) => {
                state.complainIFLoading = true;
                state.complainIFError = null;
            })
            .addCase(fetchComplainIdData.fulfilled, (state, action) => {
                state.complainIFLoading = false;
                state.ComplainIdData = action.payload;
            })
            .addCase(fetchComplainIdData.rejected, (state, action) => {
                state.complainIFLoading = false;
                state.complainIFError = action.payload;
            })

            // Task Data
            .addCase(fetchTaskData.pending, (state) => {
                state.taskDataLoading = true;
                state.taskDataError = null;
            })
            .addCase(fetchTaskData.fulfilled, (state, action) => {
                state.taskDataLoading = false;
                state.TaskData = action.payload;
            })
            .addCase(fetchTaskData.rejected, (state, action) => {
                state.taskDataLoading = false;
                state.taskDataError = action.payload;
            })

            // SubTask Data
            .addCase(fetchSubTaskData.pending, (state) => {
                state.subTaskLoading = true;
                state.subTaskError = null;
            })
            .addCase(fetchSubTaskData.fulfilled, (state, action) => {
                state.subTaskLoading = false;
                state.SubTaskData = action.payload;
            })
            .addCase(fetchSubTaskData.rejected, (state, action) => {
                state.subTaskLoading = false;
                state.subTaskError = action.payload;
            });
    },
});

export default ShowAllTask.reducer;
